// Simple API helper for auth
const BASE = process.env.REACT_APP_API_URL || "http://localhost:3000";

export async function login(email, password) {
  const res = await fetch(`${BASE}/api/auth/login`, {
    method: "POST",
    headers: { "Content-Type": "application/json" },
    body: JSON.stringify({ email, password }),
  });

  const data = await res.json().catch(() => ({}));
  if (!res.ok) {
    const message = data?.error || data?.message || `Login failed (${res.status})`;
    const err = new Error(message);
    err.status = res.status;
    throw err;
  }

  // Return both token and user object (login route returns both)
  return { token: data.token, user: data.user };
}

export async function forgotPassword(email) {
  const res = await fetch(`${BASE}/api/auth/forgot`, {
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    body: JSON.stringify({ email })
  });

  const data = await res.json().catch(() => ({}));
  if (!res.ok) {
    const message = data?.error || data?.message || `Request failed (${res.status})`;
    const err = new Error(message);
    err.status = res.status;
    throw err;
  }

  return data;
}

// Admin-only "View as": mint a session for the target user. Returns { token, user }
// shaped exactly like login.
export async function impersonate(userId) {
  const token = localStorage.getItem('token');
  const res = await fetch(`${BASE}/api/auth/impersonate/${userId}`, {
    method: 'POST',
    headers: { 'Authorization': `Bearer ${token}` },
  });

  const data = await res.json().catch(() => ({}));
  if (!res.ok) {
    const message = data?.error || data?.message || `Impersonation failed (${res.status})`;
    const err = new Error(message);
    err.status = res.status;
    throw err;
  }

  return { token: data.token, user: data.user };
}

// End an impersonation session; re-issues a token for the original admin.
export async function stopImpersonating() {
  const token = localStorage.getItem('token');
  const res = await fetch(`${BASE}/api/auth/stop-impersonating`, {
    method: 'POST',
    headers: { 'Authorization': `Bearer ${token}` },
  });

  const data = await res.json().catch(() => ({}));
  if (!res.ok) {
    const message = data?.error || data?.message || `Failed to return to admin (${res.status})`;
    const err = new Error(message);
    err.status = res.status;
    throw err;
  }

  return { token: data.token, user: data.user };
}

export default { login, impersonate, stopImpersonating };
